import {
  parseStudentBillingPayerOverviewDto,
  type StudentBillingPayerOverviewDto
} from "@madamuh/domain";
import { apiGet } from "./client";

export async function fetchStudentBillingPayerOverview(
  tenantSlug: string
): Promise<StudentBillingPayerOverviewDto> {
  return parseStudentBillingPayerOverviewDto(await apiGet(
    `/api/v1/app/tenants/${encodeURIComponent(tenantSlug)}/billing`
  ));
}
